var _style, _g, _g2, _polygon, _polyline, _defs, _polygon2, _polyline2, _polygon3, _path, _path2, _defs2, _path3, _path4, _path5, _path6, _defs3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs4, _path15, _path16, _path17, _path18, _defs5, _path19, _path20, _path21, _path22, _defs6, _path23, _path24, _path25, _path26, _path27, _path28, _polygon4, _defs7, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _path29, _defs8, _path30, _path31, _path32, _defs9, _path33, _path34, _polygon13, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CBCBEB;}\n\t.st1{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st2{fill:none;stroke:#263238;strokeLinecap:round;strokeLinejoin:round;}\n\t.st3{fill:#263238;}\n\t.st4{clip-path:url(#SVGID_00000008108050662324270760000015638120116859363973_);}\n\t.st5{opacity:0.3;fill-opacity:0.7;enable-background:new    ;}\n\t.st6{fill:#BFBFBF;stroke:#263238;strokeLinecap:round;strokeLinejoin:round;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{clip-path:url(#SVGID_00000115474266407887963260000005113942127543208103_);}\n\t.st9{opacity:0.4;fill:#CBCBEB;enable-background:new    ;}\n\t.st10{clip-path:url(#SVGID_00000080893167585640849750000013324660791899996074_);}\n\t.st11{fill:#FFFFFF;stroke:#263238;strokeLinecap:round;strokeLinejoin:round;}\n\t.st12{clip-path:url(#SVGID_00000154424625942645406910000006612314606179892415_);}\n\t.st13{clip-path:url(#SVGID_00000007404746315283425740000004186500938728055696_);}\n\t.st14{clip-path:url(#SVGID_00000101794553030445429110000009963534021541781149_);}\n\t.st15{clip-path:url(#SVGID_00000000910005014030694850000006103840259888291203_);}\n\t.st16{fill:#CBCBEB;stroke:#263238;strokeLinecap:round;strokeLinejoin:round;}\n\t.st17{fill:#757575;stroke:#263238;strokeLinecap:round;strokeLinejoin:round;}\n\t.st18{clip-path:url(#SVGID_00000014601686828351059330000011502212378605964988_);}\n\t.st19{clip-path:url(#SVGID_00000041285535453905609050000017645502825392128947_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-516"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.1,44.1c0,0,46.7-9.5,89.2,0c26,5.8,80.8,19.5,93.7,50.6s-49.3,57.7-18.7,89.2 c13.2,13.6,76.5,31.6,72.9,119.9S345.9,446.1,217,443.7S13.7,324.1,63.6,266.4s71.3-57.9,48.7-104.9S121.1,57.6,205.1,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.1,44.1c0,0,46.7-9.5,89.2,0c26,5.8,80.8,19.5,93.7,50.6s-49.3,57.7-18.7,89.2 c13.2,13.6,76.5,31.6,72.9,119.9S345.9,446.1,217,443.7S13.7,324.1,63.6,266.4s71.3-57.9,48.7-104.9S121.1,57.6,205.1,44.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-516"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "119.4,368.4 76.3,359 82.2,332.1 125.4,341.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 91.9,
    y1: 338.9,
    x2: 117.1,
    y2: 344.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 87.8,
    y1: 340.5,
    x2: 116.6,
    y2: 346.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 87.3,
    y1: 342.9,
    x2: 116,
    y2: 349.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 86.8,
    y1: 345.4,
    x2: 115.5,
    y2: 351.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 86.3,
    y1: 347.8,
    x2: 115,
    y2: 354
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 85.7,
    y1: 350.2,
    x2: 114.5,
    y2: 356.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 85.2,
    y1: 352.6,
    x2: 113.9,
    y2: 358.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 84.7,
    y1: 355,
    x2: 109.9,
    y2: 360.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "161.7,136.1 118.6,126.7 124.5,99.8 167.8,109.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 134.3,
    y1: 106.5,
    x2: 159.5,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130.2,
    y1: 108.2,
    x2: 158.9,
    y2: 114.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.7,
    y1: 110.6,
    x2: 158.4,
    y2: 116.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.2,
    y1: 113,
    x2: 157.9,
    y2: 119.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 128.6,
    y1: 115.4,
    x2: 157.4,
    y2: 121.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 128.1,
    y1: 117.8,
    x2: 156.8,
    y2: 124.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 127.6,
    y1: 120.2,
    x2: 156.3,
    y2: 126.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 127.1,
    y1: 122.7,
    x2: 152.2,
    y2: 128.2
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "383.8,89.3 340.7,79.9 346.6,53 389.8,62.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 356.3,
    y1: 59.8,
    x2: 381.5,
    y2: 65.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 352.3,
    y1: 61.4,
    x2: 381,
    y2: 67.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 351.7,
    y1: 63.8,
    x2: 380.5,
    y2: 70.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 351.2,
    y1: 66.2,
    x2: 379.9,
    y2: 72.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 350.7,
    y1: 68.7,
    x2: 379.4,
    y2: 74.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 350.2,
    y1: 71.1,
    x2: 378.9,
    y2: 77.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 349.6,
    y1: 73.5,
    x2: 378.4,
    y2: 79.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 349.1,
    y1: 75.9,
    x2: 374.3,
    y2: 81.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "360.5,396.8 323.4,420.6 308.5,397.4 345.8,373.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 320.2,
    y1: 395.3,
    x2: 341.9,
    y2: 381.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 318.5,
    y1: 399.3,
    x2: 343.2,
    y2: 383.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 319.8,
    y1: 401.4,
    x2: 344.5,
    y2: 385.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 321.1,
    y1: 403.5,
    x2: 345.9,
    y2: 387.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 322.5,
    y1: 405.6,
    x2: 347.2,
    y2: 389.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 323.8,
    y1: 407.6,
    x2: 348.6,
    y2: 391.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 325.1,
    y1: 409.7,
    x2: 349.9,
    y2: 393.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 326.5,
    y1: 411.8,
    x2: 348.2,
    y2: 397.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "434.4,314.7 393.1,330.1 383.5,304.3 425,288.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 395.4,
    y1: 304.7,
    x2: 419.5,
    y2: 295.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 392.8,
    y1: 308.3,
    x2: 420.4,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 393.7,
    y1: 310.6,
    x2: 421.2,
    y2: 300.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 394.5,
    y1: 312.9,
    x2: 422.1,
    y2: 302.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 395.4,
    y1: 315.3,
    x2: 423,
    y2: 305
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 396.3,
    y1: 317.6,
    x2: 423.8,
    y2: 307.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 397.1,
    y1: 319.9,
    x2: 424.7,
    y2: 309.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 398,
    y1: 322.2,
    x2: 422.2,
    y2: 313.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drawer--inject-516"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "330.6,168 169.4,168 149.3,67.9 350.7,67.9  "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "164.4,71.2 134.8,273 365.2,273 335.6,71.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "164.4,71.2 134.8,273 365.2,273 335.6,71.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050639544893593596170000008005981462729445262_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000050639544893593596170000008005981462729445262_)"
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "365.2,273 134.8,273 147.2,188.6 352.8,188.6  "
  })))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "164.4,71.2 134.8,273 365.2,273 335.6,71.2  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "329.3,71.2 170.7,71.2 143.2,273 356.8,273  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.6,86.6h-86.1l-1-2.2c-0.5-1.2-1.8-2-3.1-2h-19.5c-1.1,0-2,0.9-2,2v2.2h-15.6c-1,0-1.9,0.9-1.9,1.9 c0,0.1,0,0.2,0,0.4l12.7,63.2h105.5l12.7-63.2c0.2-1-0.4-2-1.4-2.3C313.9,86.6,313.8,86.6,313.6,86.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M316.9,91.4l-1.1,5.5l-11.3,56.2c-0.3,1.7-1.9,3-3.6,3H199.1c-1.8,0-3.3-1.3-3.6-3L184,95.5l-0.8-4.1 c-0.2-1,0.5-2,1.5-2.2c0.1,0,0.2,0,0.3,0h130c1,0,1.9,0.8,1.9,1.9C316.9,91.2,316.9,91.3,316.9,91.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000042732977737692769140000008883137229620208806_",
    d: "M316.9,91.4l-1.1,5.5l-11.3,56.2c-0.3,1.7-1.9,3-3.6,3 H199.1c-1.8,0-3.3-1.3-3.6-3L184,95.5l-0.8-4.1c-0.2-1,0.5-2,1.5-2.2c0.1,0,0.2,0,0.3,0h130c1,0,1.9,0.8,1.9,1.9 C316.9,91.2,316.9,91.3,316.9,91.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039832612831725057720000007181630214974017187_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042732977737692769140000008883137229620208806_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039832612831725057720000007181630214974017187_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M315.8,96.9l-11.3,56.2c-0.3,1.7-1.9,3-3.6,3H199.1c-1.8,0-3.3-1.3-3.6-3L184,95.5L315.8,96.9z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.9,91.4l-1.1,5.5l-11.3,56.2c-0.3,1.7-1.9,3-3.6,3H199.1c-1.8,0-3.3-1.3-3.6-3L184,95.5l-0.8-4.1 c-0.2-1,0.5-2,1.5-2.2c0.1,0,0.2,0,0.3,0h130c1,0,1.9,0.8,1.9,1.9C316.9,91.2,316.9,91.3,316.9,91.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M315.2,101.1H227l-1-2.2c-0.6-1.2-1.8-2-3.2-2h-20c-1.1,0-2,0.9-2,2v2.2h-16c-1.1,0-1.9,0.8-1.9,1.9 c0,0.1,0,0.3,0,0.4l13,63.1H304l13-63.1c0.2-1-0.4-2-1.5-2.3C315.4,101.1,315.3,101.1,315.2,101.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.5,106.2l-1.1,5.3l-11.6,56.1c-0.4,1.8-1.9,3-3.7,3H197.9c-1.8,0-3.4-1.2-3.7-3l-11.6-56.3l-1.1-5.2 c-0.2-1,0.5-2,1.5-2.2c0.1,0,0.3,0,0.4,0h133.2c1.1,0,1.9,0.8,1.9,1.9C318.5,105.9,318.5,106,318.5,106.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000092456406347504471340000009194784173366036881_",
    d: "M318.5,106.2l-1.1,5.3l-11.6,56.1c-0.4,1.8-1.9,3-3.7,3 H197.9c-1.8,0-3.4-1.2-3.7-3l-11.6-56.3l-1.1-5.1c-0.2-1,0.5-2,1.5-2.2c0.1,0,0.3,0,0.4,0h133.2c1.1,0,1.9,0.8,1.9,1.9 C318.5,105.9,318.5,106,318.5,106.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008106870296520674860000011277784983519116721_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092456406347504471340000009194784173366036881_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000008106870296520674860000011277784983519116721_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M317.4,111.5l-11.6,56.1c-0.4,1.8-1.9,3-3.7,3H197.9c-1.8,0-3.4-1.2-3.7-3l-11.6-56.3L317.4,111.5z"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.5,106.2l-1.1,5.3l-11.6,56.1c-0.4,1.8-1.9,3-3.7,3H197.9c-1.8,0-3.4-1.2-3.7-3l-11.6-56.3l-1.1-5.2 c-0.2-1,0.5-2,1.5-2.2c0.1,0,0.3,0,0.4,0h133.2c1.1,0,1.9,0.8,1.9,1.9C318.5,105.9,318.5,106,318.5,106.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.7,115.7h-90.2l-1-2.2c-0.6-1.2-1.9-2-3.2-2h-20.5c-1.1,0-2,0.8-2.1,1.9c0,0,0,0,0,0.1v2.2h-16.3 c-1.1,0-1.9,0.8-2,1.9c0,0.1,0,0.3,0,0.4l13.3,62.9h110.6l13.3-62.9c0.2-1-0.5-2.1-1.5-2.3C317,115.7,316.8,115.7,316.7,115.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M318.1,118.6H181.9c-1.1,0-1.9,0.8-2,1.8c0,0.1,0,0.3,0,0.4l13,61.3c0.4,1.8,2,3,3.8,3h106.6 c1.8,0,3.4-1.2,3.8-3l13-61.3c0.2-1-0.5-2-1.5-2.2C318.4,118.6,318.3,118.6,318.1,118.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M318.2,127.3h-92.3l-1.1-2.2c-0.6-1.2-1.9-2-3.3-2h-21c-1.1-0.1-2,0.8-2.1,1.9c0,0,0,0.1,0,0.1v2.2h-16.7 c-1.1-0.1-2,0.8-2,1.8c0,0.1,0,0.3,0,0.4l13.6,62.7h113.2l13.6-62.7c0.2-1-0.5-2.1-1.5-2.3C318.5,127.3,318.4,127.3,318.2,127.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.7,130.4H180.3c-1.1-0.1-2,0.8-2,1.8c0,0.1,0,0.3,0,0.4l13.3,61.1c0.4,1.8,2.1,3,3.9,2.9h109 c1.8,0.1,3.4-1.2,3.9-2.9l13.3-61.1c0.2-1.1-0.5-2-1.6-2.2C320,130.4,319.8,130.4,319.7,130.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M319.7,138.8h-94.3l-1.1-2.2c-0.7-1.3-2-2-3.4-2h-21.4c-1.1-0.1-2.1,0.8-2.1,1.9v2.2h-17.1c-1.1,0-2,0.9-2,2 c0,0.1,0,0.2,0,0.3l13.9,62.5h115.6l13.9-62.5c0.1-1.1-0.7-2.1-1.8-2.2C319.9,138.8,319.8,138.8,319.7,138.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M321.2,142.1H178.8c-1.1,0-2,0.8-2,1.9c0,0.1,0,0.3,0,0.4l3.3,15l10.2,45.9c0.5,1.8,2.1,3,4,2.9h111.4 c1.9,0.1,3.5-1.2,4-2.9l5-22.5l8.6-38.4c0.2-1.1-0.5-2.1-1.6-2.2C321.5,142.1,321.4,142.1,321.2,142.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000137126131924867065590000000630649209092671391_",
    d: "M321.2,142.1H178.8c-1.1,0-2,0.8-2,1.9 c0,0.1,0,0.3,0,0.4l3.3,15l10.2,45.9c0.5,1.8,2.1,3,4,2.9h111.4c1.9,0.1,3.5-1.2,4-2.9l5-22.5l8.6-38.4c0.2-1.1-0.5-2.1-1.6-2.2 C321.5,142.1,321.4,142.1,321.2,142.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131353991719202681840000000273161523241271466_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137126131924867065590000000630649209092671391_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000131353991719202681840000000273161523241271466_)"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180.1,159.4l10.2,45.9c0.5,1.8,2.1,3,4,2.9h111.4c1.9,0.1,3.5-1.2,4-2.9l5-22.5L180.1,159.4z"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.2,142.1H178.8c-1.1,0-2,0.8-2,1.9c0,0.1,0,0.3,0,0.4l3.3,15l10.2,45.9c0.5,1.8,2.1,3,4,2.9h111.4 c1.9,0.1,3.5-1.2,4-2.9l5-22.5l8.6-38.4c0.2-1.1-0.5-2.1-1.6-2.2C321.5,142.1,321.4,142.1,321.2,142.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.8,210.4l-1.3-2.1c-0.8-1.2-2.3-1.9-3.8-1.8l-23.3,1.1c-1.2,0-2.2,0.8-2.2,2l0.1,2.2l-18.6,0.9 c-1.4,0.1-2.4,1.2-2.1,2.3l18,61l125.6-5.8l12.3-62.4c0.2-1.2-0.9-2.2-2.3-2.1L221.8,210.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M328.4,211.7l-1.4,7.2l-10.6,53.6c-0.5,1.9-2.3,3.1-4.2,3.1l-121.1,5.6c-1.9,0.2-3.8-0.9-4.5-2.7L170,221.7 l-0.8-2.8c-0.3-1.1,0.7-2.2,2.1-2.3l154.8-7.1C327.5,209.5,328.6,210.5,328.4,211.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000026143005570206690210000004317775624263749554_",
    d: "M328.4,211.7l-1.4,7.2l-10.6,53.6 c-0.5,1.9-2.3,3.1-4.2,3.1l-121.1,5.6c-1.9,0.2-3.8-0.9-4.5-2.7L170,221.7l-0.8-2.8c-0.3-1.1,0.7-2.2,2.1-2.3l154.8-7.1 C327.5,209.5,328.6,210.5,328.4,211.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062896494269187020000000004398359562267752890_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026143005570206690210000004317775624263749554_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000062896494269187020000000004398359562267752890_)"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M327,218.9l-10.6,53.6c-0.5,1.9-2.3,3.1-4.2,3.1l-121.1,5.6c-1.9,0.2-3.8-0.9-4.5-2.7L170,221.7L327,218.9z"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.4,211.7l-1.4,7.2l-10.6,53.6c-0.5,1.9-2.3,3.1-4.2,3.1l-121.1,5.6c-1.9,0.2-3.8-0.9-4.5-2.7L170,221.7 l-0.8-2.8c-0.3-1.1,0.7-2.2,2.1-2.3l154.8-7.1C327.5,209.5,328.6,210.5,328.4,211.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.4,224.3l-1.1-2.2c-0.7-1.3-2.1-2.1-3.7-2.2l-23.7-1.2c-1.2-0.2-2.3,0.6-2.5,1.8l-0.1,2.2l-18.9-1 c-1.4-0.1-2.6,0.9-2.4,2.1l12.2,62.3l128.1,6.7l18.6-60.7c0.3-1.1-0.7-2.2-2.1-2.3L224.4,224.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M332.6,236.3l-3,9.9l-15.1,49.3c-0.7,1.8-2.6,2.9-4.6,2.7l-123.5-6.5c-2,0-3.7-1.2-4.3-3.1l-10.4-53.3 l-1.5-7.4c-0.2-1.1,0.9-2.2,2.4-2.1l157.8,8.2C331.9,234.1,332.9,235.2,332.6,236.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000181082624885077072980000007583670850043382184_",
    d: "M332.6,236.3l-3,9.9l-15.1,49.3 c-0.7,1.8-2.6,2.9-4.6,2.7l-123.5-6.5c-2,0-3.7-1.2-4.3-3.1l-10.4-53.3l-1.5-7.5c-0.2-1.2,0.9-2.2,2.4-2.1l157.8,8.2 C331.9,234.1,332.9,235.2,332.6,236.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168118728681347305350000004694278295908980651_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181082624885077072980000007583670850043382184_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000168118728681347305350000004694278295908980651_)"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M329.5,246.2l-15.1,49.3c-0.7,1.8-2.6,2.9-4.6,2.7l-123.5-6.5c-2,0-3.7-1.2-4.3-3.1l-10.4-53.3L329.5,246.2z "
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.6,236.3l-3,9.9l-15.1,49.3c-0.7,1.8-2.6,2.9-4.6,2.7l-123.5-6.5c-2,0-3.7-1.2-4.3-3.1l-10.4-53.3 l-1.5-7.4c-0.2-1.1,0.9-2.2,2.4-2.1l157.8,8.2C331.9,234.1,332.9,235.2,332.6,236.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.2,240.3l-1.2-2.1c-0.8-1.3-2.3-2.1-3.8-2h-24.3c-1.2-0.1-2.3,0.7-2.4,1.9v2.2h-19.3 c-1.5,0-2.6,1.1-2.3,2.2l15.8,61.4h130.8l15.8-61.4c0.3-1.1-0.8-2.2-2.3-2.2L222.2,240.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M313,309.5H187c-2.2,0-4.1-1.2-4.5-2.9l-15.4-59.8c-0.3-1.1,0.8-2.2,2.3-2.2h161.2c1.5,0,2.6,1.1,2.3,2.2 l-15.4,59.8C317.1,308.3,315.2,309.5,313,309.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.6,254.8l-1.2-2.1c-0.9-1.3-2.4-2-3.9-1.9h-24.7c-1.2-0.1-2.3,0.7-2.5,1.9v2.2h-19.7 c-1.5,0-2.6,1.1-2.4,2.2l16.1,61.2h133.4l16.1-61.2c0.3-1.1-0.8-2.2-2.4-2.2L221.6,254.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M314.3,324H185.7c-2.2,0-4.1-1.2-4.6-2.9l-15.7-59.6c-0.3-1.1,0.8-2.2,2.4-2.2h164.3c1.5,0,2.6,1.1,2.4,2.2 l-15.7,59.6C318.4,322.8,316.5,324,314.3,324z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.4,393 159.6,393 120.1,280.8 379.9,280.8  "
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116954550604686733210000014907295473863316409_",
    points: "340.4,393 159.6,393 120.1,280.8 379.9,280.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128479005468387892420000013143647178573224635_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116954550604686733210000014907295473863316409_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000128479005468387892420000013143647178573224635_)"
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "340.4,393 159.6,393 120.1,280.8 379.9,280.8  "
  })))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "340.4,393 159.6,393 120.1,280.8 379.9,280.8  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "376.5,266 123.5,266 120.1,280.8 379.9,280.8  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "187.3,332.2 184.7,356.1 315.3,356.1 312.7,332.2 307,332.2 308.6,349.3 191.4,349.3 193,332.2  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "314.3,361.6 185.7,361.6 184.7,356.1 315.3,356.1  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "307,332.2 306.2,338.5 307,349.3 308.6,349.3  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "193,332.2 193.8,338.5 193,349.3 191.4,349.3  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "292.1,320.2 207.9,320.2 203.9,299.8 296.1,299.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--right-hand--inject-516"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M255.6,123.5l-0.8-2.3c-0.5-1.4-1.8-2.3-3.3-2.5l-22.2-2.9c-1.2-0.2-2.3,0.5-2.5,1.7l-0.3,2.2l-17.7-2.3 c-1.1-0.2-2.1,0.5-2.4,1.5c0,0.1,0,0.3,0,0.5l6.3,65.1l120,15.5l22.6-61.4c0.3-1.1-0.3-2.2-1.4-2.5c-0.1,0-0.3-0.1-0.4-0.1 L255.6,123.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000180351281224507840240000017835631627527425188_",
    d: "M255.6,123.5l-0.8-2.3c-0.5-1.4-1.8-2.3-3.3-2.5 l-22.2-2.9c-1.2-0.2-2.3,0.5-2.5,1.7l-0.3,2.2l-17.7-2.3c-1.1-0.2-2.1,0.5-2.4,1.5c0,0.1,0,0.3,0,0.5l6.3,65.1l120,15.5 l22.6-61.4c0.3-1.1-0.3-2.2-1.4-2.5c-0.1,0-0.3-0.1-0.4-0.1L255.6,123.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121960893695394507990000015629606998248522897_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180351281224507840240000017835631627527425188_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000121960893695394507990000015629606998248522897_)"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M255.6,123.5l-0.8-2.3c-0.5-1.4-1.8-2.3-3.3-2.5l-22.2-2.9c-1.2-0.2-2.3,0.5-2.5,1.7l-0.3,2.2l-17.7-2.3 c-1.1-0.2-2.1,0.5-2.4,1.5c0,0.1,0,0.3,0,0.5l6.3,65.1l120,15.5l22.6-61.4c0.3-1.1-0.3-2.2-1.4-2.5c-0.1,0-0.3-0.1-0.4-0.1 L255.6,123.5z"
  })))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.6,123.5l-0.8-2.3c-0.5-1.4-1.8-2.3-3.3-2.5l-22.2-2.9c-1.2-0.2-2.3,0.5-2.5,1.7l-0.3,2.2l-17.7-2.3 c-1.1-0.2-2.1,0.5-2.4,1.5c0,0.1,0,0.3,0,0.5l6.3,65.1l120,15.5l22.6-61.4c0.3-1.1-0.3-2.2-1.4-2.5c-0.1,0-0.3-0.1-0.4-0.1 L255.6,123.5z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M356.5,142.4L336,198l-1.6,4.3c-0.8,1.8-2.6,2.8-4.5,2.4l-115.7-14.9c-1.9-0.2-3.5-1.6-3.7-3.5l-6.1-63.5 c0-1.1,0.9-2,2-2c0.2,0,0.3,0,0.5,0l98.4,12.7l49.5,6.4c1.1,0.1,2,1,1.9,2.1C356.5,142.1,356.5,142.2,356.5,142.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096052656709262818060000017487034953563231890_",
    d: "M356.5,142.4L336,198l-1.6,4.3 c-0.8,1.8-2.6,2.8-4.5,2.4l-115.7-14.9c-1.9-0.2-3.5-1.6-3.7-3.5l-6.1-63.5c0-1.1,0.9-2,2-2c0.2,0,0.3,0,0.5,0l98.4,12.7 l49.5,6.4c1.1,0.1,2,1,1.9,2.1C356.5,142.1,356.5,142.2,356.5,142.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039127957208283013510000006304112170813142200_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096052656709262818060000017487034953563231890_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039127957208283013510000006304112170813142200_)"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M356.5,142.4L336,198c-14.5-3.4-15.1-12.5-17.5-17.1c-2.7-5.2-19.7-7.9-24.4-8.7s-7.6-5.6-7.6-5.6 c-4.3-12,18.1-22.5,18.1-22.5c-0.4-1.6,0.2-7.1,0.7-10.5l49.5,6.4c1.1,0.1,2,1,1.9,2.1C356.5,142.1,356.5,142.3,356.5,142.4z"
  })))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M356.5,142.4L336,198l-1.6,4.3c-0.8,1.8-2.6,2.8-4.5,2.4l-115.7-14.9c-1.9-0.2-3.5-1.6-3.7-3.5l-6.1-63.5 c0-1.1,0.9-2,2-2c0.2,0,0.3,0,0.5,0l98.4,12.7l49.5,6.4c1.1,0.1,2,1,1.9,2.1C356.5,142.1,356.5,142.2,356.5,142.4z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "226.1,139.9 227.7,179.2 241.9,181 243.6,141.9  "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.8,176.3c0.4-1.4,0.1-2.9-0.7-4.1c-0.8-1.2-1.8-2.3-2.9-3.2c1.7,0.9,3.5,1.6,5.4,1.8c0-2.1-2-3.5-3.7-4.6 c0.8-0.3,1.7-0.2,2.4,0.2c0.1-0.6-0.2-1.3-0.7-1.7c0.2,0.2,0.6-0.1,0.6-0.4c-0.1-0.3-0.2-0.5-0.4-0.8c-0.3-0.6-0.4-1.3-0.3-1.9 c0-2.4,0.1-4.7,0.1-7.1c0.1,0.4,0.4,0.8,0.8,0.9c0-0.9-0.1-1.9-0.2-2.8c-0.2-2.4-0.4-4.7-0.7-7.1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M461,267.7c0,0-80.7-72.2-85.8-76.8s-8.9-4.4-11.7-7.1s-4.2-4.7-15.4-4.6s-26.3-5.9-29.7-8.1 s-8.1-0.6-11.3-1.8s-11.3-0.1-16.2,0s-5.3-4.9-3.4-10.6s17-9.3,19-8.1s9.9-2.2,9.9-2.2c-1.2-4.2-0.8-14.2-0.8-14.2 s-8.3-3.6-11.5-4.7c-2.4-0.7-5-1-7.5-0.8c0,0,1-4.5,2.6-6.2s9.1-3.3,16.4-8.4s11.9-6.3,13-5.9s9.3,2.8,11.5,2.8s5.3-2,8.5-1.4 s8.9,5.5,11.5,6.1s3.4,1.1,6.7,1.1c1.5,0,7.5,4.4,7.5,4.4c2.5,0.5,5,1.3,7.3,2.4c3.8,1.8,7.7,10.3,9.5,13.1s2,9.5,2,9.5 s4.8,2.6,6.5,6.1s67.3,38.8,67.3,38.8S477.3,231.4,461,267.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M403.5,216.2c-14.5-12.9-26.5-23.7-28.3-25.3c-5.1-4.6-8.9-4.4-11.7-7.1s-4.2-4.7-15.4-4.6s-26.3-5.9-29.7-8.1 s-8.1-0.6-11.3-1.8s-11.3-0.1-16.2,0s-5.3-4.9-3.4-10.6s17-9.3,19-8.1s9.9-2.2,9.9-2.2c-1.2-4.2-0.8-14.2-0.8-14.2 s-8.3-3.6-11.5-4.7c-2.4-0.7-5-1-7.5-0.8c0,0,1-4.5,2.6-6.2s9.1-3.3,16.4-8.4s11.9-6.3,13-5.9s9.3,2.8,11.5,2.8 c1.6,0,3.9-1.1,6.2-1.4c-1.9,1.1-3.2,3.1-2.9,4.2c0.6,1.7,2.2,6.1,2.3,6.4c-0.4-0.4-10.8-10.7-17.5-10.1 c-5.8,0.4-11.7,10.2-10.7,17.4s-1.4,7.2-0.1,12.5s2.5,12.9,0.5,15.8s-5.9-2.3-5.9-2.3c-3,1.7-4.9,4.8-5,8.2c0,5.7,6,6.1,9.5,6.7 s16.6,7.8,25.5,8.1l8.9,0.4c0,0-5.1-7-3-7.4s8.7,0.3,13,7s7.6,8.2,15.6,11.5C381.3,189.7,393.7,203.1,403.5,216.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M443.1,177.9c-1.2-0.6-40-18.9-42-21.6s-4.4-3.4-6.5-6.1s-9.5-4.5-10.5-8.3s-2.2-15.2-4-16.6 c-1.5-1.1-3.1-2.1-4.7-2.9l2.9,7.3c0,0-6.7-9.5-8.3-9.8s1.7,6.9,1.4,6.7s-7.5-7-13.6-12.1c0.7,0.4,1.5,0.8,2.3,1 c2.6,0.6,3.4,1.1,6.7,1.1c1.5,0,7.5,4.4,7.5,4.4c2.5,0.5,5,1.3,7.3,2.4c3.8,1.8,7.7,10.3,9.5,13.1s2,9.5,2,9.5s4.8,2.6,6.5,6.1 C400.8,154.3,424.2,167.5,443.1,177.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M443.1,177.9L443.1,177.9z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M461,267.7c0,0-80.7-72.2-85.8-76.8s-8.9-4.4-11.7-7.1s-4.2-4.7-15.4-4.6s-26.3-5.9-29.7-8.1 s-8.1-0.6-11.3-1.8s-11.3-0.1-16.2,0s-5.3-4.9-3.4-10.6s17-9.3,19-8.1s9.9-2.2,9.9-2.2c-1.2-4.2-0.8-14.2-0.8-14.2 s-8.3-3.6-11.5-4.7c-2.4-0.7-5-1-7.5-0.8c0,0,1-4.5,2.6-6.2s9.1-3.3,16.4-8.4s11.9-6.3,13-5.9s9.3,2.8,11.5,2.8s5.3-2,8.5-1.4 s8.9,5.5,11.5,6.1s3.4,1.1,6.7,1.1c1.5,0,7.5,4.4,7.5,4.4c2.5,0.5,5,1.3,7.3,2.4c3.8,1.8,7.7,10.3,9.5,13.1s2,9.5,2,9.5 s4.8,2.6,6.5,6.1s67.3,38.8,67.3,38.8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M315.7,134.2c0,0,0.9-7.8,0-8.9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340,115.1c0,0,13.5,11.4,14.5,12.1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.7,111.3c1.9,1.2,16.8,14.4,21.6,17.4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M393.2,146c-1.5-0.9-5.3-2.7-5.7-4.1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.5,148.4c0,0,0.8,3.2,0,4.8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.6,158.6c0,0-1.8,5.1,2.5,8.6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M322.5,109.8c-1.4,1.5-2.3,3.3-2.6,5.3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302,125.3c0.9,2.4,2.8,4.3,5.1,5.3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M361.1,181.6c-2.6-3.7-5.4-7.3-8.5-10.6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--left-hand--inject-516"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.5,445.3c0,0,64.6-42.5,68.6-47.9c2-3,4.4-5.6,7.1-8c0,0,1.9-15.8,6.6-24s6.6-14.2,8.7-18.5s12.1-7.4,15-9 s7.9-4.8,10.8-4.8c2.2,0.2,4.4,0.8,6.3,1.9c0,0,9.8-5,14.2-1.9c0,0,11.1,0.5,13.7,0.3s6.6,1.6,6.6,1.6s6.6-4.7,11.1-2.9 c4.5,1.8,6.6,2.6,6.7,5.3s-1.1,11.6-1.1,11.6h-2.2c0,0-7.4,9.6-8.2,11.5s-5,12.5-5,12.5s5.5-4.2,9-7.4s9.5-9.2,15.8-10.8 s10.8,2,10.8,5.7c0,0-7.4,5.9-9,7.7s-4.4,6.6-7.6,10S252,396,245.6,402.9s-34,21.6-40.4,23.7c0,0-38.5,26.9-55.4,49.6 C149.9,476.2,104,476.4,84.5,445.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M209.8,420.8c0.6,0.6,2.8,0.9,6,1c-3.4,1.8-6.9,3.4-10.5,4.8c0,0-25.2,17.6-43.7,36.3 c6.4-10.2,18.7-22.9,23.2-25.5c6.4-3.7,18.6-15.6,18.6-15.6S207.9,418.9,209.8,420.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M252.5,365.7c2.7-2.7,5.6-5.1,8.7-7.3c-3.3,3.6-5.9,7.7-7.8,12.1c-1.2,6.6-12.7,20.3-12.7,20.3 c3.7-11.9,0.5-14.2,1.6-17.7s1.7-11.8,1.7-11.8s2-3.5,4.1-4.2s7.6-14.8,8.7-16.7s-6.8-5-8.9-5.2s-2.9,3.4-7.1,5.2 s-9.5,5.1-11.5,7.1s-5.3,10.5-5.6,11c0.1-0.6,2.5-10.2,3.2-12.1c0.5-1.6,5.6-4.5,7.5-5.6c-3.1,1.5-4.9-1.3-7.5-3.8 c-2.8-2.7-6.9-3.5-11.5-2.1s-7.6,4.8-7.6,4.6s-6.8-1.5-9-0.8s-7.3,3-7.3,3s-4.6-2.7-12.2,4.8c-3.2,3.1-13.7,27-12.1,24.1 s8.5-11.4,8.9-11.9c-0.5,1.1-14.4,32.5-17.3,34.5s-3.7,9.1-14,14.9c-9.8,5.5-47.5,29.2-51.2,31.6c17.9-11.9,56.6-37.9,59.6-42.1 c2-3,4.4-5.6,7.1-8c0,0,1.9-15.8,6.6-24s6.6-14.2,8.7-18.5s12.1-7.4,15-9s7.9-4.8,10.8-4.8c2.2,0.2,4.4,0.8,6.3,1.9 c0,0,9.8-5,14.2-1.9c0,0,11.1,0.5,13.7,0.3s6.6,1.6,6.6,1.6s6.6-4.7,11.1-2.9c4.5,1.8,6.6,2.6,6.7,5.3s-1.1,11.6-1.1,11.6h-2.2 c0,0-7.4,9.6-8.2,11.5s-5,12.5-5,12.5S249,368.8,252.5,365.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M279.1,360.6c0,0-7.4,5.9-9,7.7c-1,1.1-2.4,3.3-4,5.6c0.8-2.7,1.4-5.4,1.7-8.2c1.6-2.3,3.8-4,6.3-5 c1.6-0.5,3.3-0.6,5-0.4C279.1,360.4,279.1,360.5,279.1,360.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.5,445.3c0,0,64.6-42.5,68.6-47.9c2-3,4.4-5.6,7.1-8c0,0,1.9-15.8,6.6-24s6.6-14.2,8.7-18.5s12.1-7.4,15-9 s7.9-4.8,10.8-4.8c2.2,0.2,4.4,0.8,6.3,1.9c0,0,9.8-5,14.2-1.9c0,0,11.1,0.5,13.7,0.3s6.6,1.6,6.6,1.6s6.6-4.7,11.1-2.9 c4.5,1.8,6.6,2.6,6.7,5.3s-1.1,11.6-1.1,11.6h-2.2c0,0-7.4,9.6-8.2,11.5s-5,12.5-5,12.5s5.5-4.2,9-7.4s9.5-9.2,15.8-10.8 s10.8,2,10.8,5.7c0,0-7.4,5.9-9,7.7s-4.4,6.6-7.6,10S252,396,245.6,402.9s-34,21.6-40.4,23.7c0,0-38.5,26.9-55.4,49.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243.5,373c0,0,1.6,7.9-1.6,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M233.2,341.1c3.3-1.5,6.4-3.6,9-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.7,349c0.9-1.7,1.4-3.6,1.7-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.9,333.2c-3.2-0.1-6.3,1-8.8,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.6,335.1c0,0-7.9,3.7-10.7,3.7s-7.3,3.7-7.3,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.2,389.4c2.3-3.6,4.2-7.4,5.7-11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.9,343.5c0,0-5,1.3-6.7,5.5s-9.6,18.9-9.6,18.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.8,341.1c-1.1,2.5-12.9,24.5-12.9,24.5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "129.4,226.3 86.7,237.7 79.7,211.1 122.4,199.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 91.4,
    y1: 212.6,
    x2: 116.3,
    y2: 206
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 88.6,
    y1: 215.9,
    x2: 117,
    y2: 208.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 89.2,
    y1: 218.3,
    x2: 117.6,
    y2: 210.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 89.8,
    y1: 220.7,
    x2: 118.2,
    y2: 213.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90.5,
    y1: 223.1,
    x2: 118.9,
    y2: 215.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 91.1,
    y1: 225.5,
    x2: 119.5,
    y2: 217.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 91.7,
    y1: 227.9,
    x2: 120.1,
    y2: 220.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 92.4,
    y1: 230.2,
    x2: 117.3,
    y2: 223.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.4d1e613c67c84d513867d5c569a57984.svg";
export { ForwardRef as ReactComponent };